import { Box, Divider, Typography } from "@mui/material"
import { useNavigate, useSearch } from "@tanstack/react-router"
import type { FC } from "react"

import { DistributorMultiSelect } from "./DistributorMultiSelect"

export const CompetitorProductsFilter: FC = () => {
  const navigate = useNavigate({ from: "/app/admin/manage-products/competitor-products" })
  const currentSearch = useSearch({ from: "/app/admin/manage-products/_layout/competitor-products" })

  const selectedDistributorIds = currentSearch?.distributorIds || []

  const handleDistributorsChange = (distributorIds: string[]) => {
    navigate({
      search: (prev) => ({
        ...prev,
        distributorIds: distributorIds.length > 0 ? distributorIds : undefined,
      }),
      replace: true,
    })
  }

  return (
    <Box className='h-full min-w-80'>
      <Box className='flex flex-1 flex-col'>
        <Typography variant='subtitle1' className='px-4 py-1.5 font-bold text-gray-700'>
          Distributor
        </Typography>
        <Divider />
        <Box className='p-4'>
          <DistributorMultiSelect
            id='distributor-filter'
            value={selectedDistributorIds}
            onChange={handleDistributorsChange}
          />
        </Box>
      </Box>
    </Box>
  )
}
